//

import { compose } from 'redux';
import { get } from 'lodash-es';

import { isLoading } from 'store/status';
import { Loader } from 'modules/v2/common/components';
import { ChangePasswordForm } from 'modules/v2/components';
import { ProfileTemplate } from 'modules/v2/templates';
import { withPassword, withProfile } from 'modules/v2/containers';
import { Box } from 'modules/v2/common/AtomicDesign/atoms';
import { withAuth } from 'modules/auth/containers';

const Password = ({ avatar, password, profile, updatePassword, signOut }) => {
  const { data } = profile;
  const email = get(data, 'email');
  const firstName = get(data, 'firstName');

  const handleSave = (fields) => {
    const { newPassword, oldPassword } = fields;

    updatePassword(oldPassword, newPassword);
  };

  const loading = isLoading(password.status);

  const content = loading ? (
    <Loader title="Updating password" height="100%" />
  ) : (
    <div className="max-w-[486px]">
      <ChangePasswordForm onSave={handleSave} />
    </div>
  );

  return (
    <ProfileTemplate
      avatar={avatar}
      email={email}
      title="Password Update"
      username={firstName}
      onLogout={signOut}
      sidebarWidth={0}
      noPaddingLeft
      noPaddingRight
    >
      <Box>
        <div className="text-base font-semibold px-6 py-[22px]  text-boxTitle border-b border-neutral-200">
          Change password
        </div>
        <div className="p-6">{content}</div>
      </Box>
    </ProfileTemplate>
  );
};

const Composed = compose(withPassword, withProfile, withAuth)(Password);

export default Composed;
